import { atom } from 'jotai';

const DEFAULT_STATE = {
  assignedChecklist: false,
  assignedCompliance: false,
  assignedTeamMembers: false,
  courseReport: false,
};

type ManagePlansState = typeof DEFAULT_STATE & {
  shouldRefetchAssignedChecklist: boolean;
  shouldRefetchAssignedCompliance: boolean;
  shouldRefetchAssignedTeamMembers: boolean;
  shouldRefetchCourseReport: boolean;
};

const base = atom(DEFAULT_STATE);

export const managePlansAtom = atom<
  ManagePlansState,
  [Partial<typeof DEFAULT_STATE>],
  undefined
>(
  get => {
    const s = get(base);
    return {
      ...s,
      shouldRefetchAssignedChecklist: s.assignedChecklist,
      shouldRefetchAssignedCompliance: s.assignedCompliance,
      shouldRefetchAssignedTeamMembers: s.assignedTeamMembers,
      shouldRefetchCourseReport: s.courseReport,
    };
  },
  (get, set, patch) => {
    const s = get(base);
    set(base, { ...s, ...patch });
  },
);

type Actions =
  | 'refetchAssignedChecklist'
  | 'refetchCompliance'
  | 'refetchAssignedTeamMembers'
  | 'refetchCourseReport';

export const toggleRefetchDispatchAtom = atom(null, (get, set, a: Actions) => {
  const s = get(base);
  switch (a) {
    case 'refetchAssignedChecklist':
      return set(base, {
        ...s,
        assignedChecklist: !s.assignedChecklist,
      });
    case 'refetchCompliance':
      return set(base, {
        ...s,
        assignedCompliance: !s.assignedCompliance,
      });
    case 'refetchAssignedTeamMembers':
      return set(base, {
        ...s,
        assignedTeamMembers: !s.assignedTeamMembers,
      });
    case 'refetchCourseReport':
      return set(base, { ...s, courseReport: !s.courseReport });
  }
});
